import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import InstallPrompt from './components/feature/InstallPrompt';
import OfflineIndicator from './components/feature/OfflineIndicator';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <OfflineIndicator />
      <AppRoutes />
      <InstallPrompt />
    </BrowserRouter>
  );
}

export default App;
